/**
 * Сериализует объект параметров в строку запроса.
 * Массивы преобразуются без квадратных скобок: array=1&array=2
 */
export default class QuerySerializer {
    static stringify(params) {
        if (!params) return '';

        const searchParams = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
            if (Array.isArray(value)) {
                value.forEach(val => {
                    if (val !== undefined && val !== null) {
                        searchParams.append(key, val);
                    }
                });
            } else if (value !== undefined && value !== null) {
                searchParams.append(key, value);
            }
        });

        return searchParams.toString();
    }
}
